// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE CLOSING DISCLOSURE PAGE BEFORE THE CLOSING DATE IS SCHEDULED (Jesse, 2026-11-02).
// GET /api/closing/status answers { state: 'closing_not_scheduled', cd: null } until staff schedule the closing (the
// CD's prepaid interest runs from that date and has no default). pages/ClosingDisclosures shows this line then.
// One switch: while CD_NOT_SCHEDULED_APPROVED is false the line is never shown and the page keeps its existing neutral
// "Loading closing details…" state. backend/test/cdNotScheduled.test.js pins both cases.
// ─────────────────────────────────────────────────────────────────────────────
export const CD_NOT_SCHEDULED_STATE = 'closing_not_scheduled';

// APPROVED (Hannah, 2026-11-02)
export const CD_NOT_SCHEDULED_APPROVED = true;
export const CD_NOT_SCHEDULED_LINE = 'Your Closing Disclosure will be ready here once your closing date is scheduled. '
  + 'We’ll let you know as soon as it’s available.';

/** The line to show for the not-scheduled state, or null while it is not approved (the page then stays neutral). */
export function cdNotScheduledLine({ approved = CD_NOT_SCHEDULED_APPROVED } = {}) {
  return approved ? CD_NOT_SCHEDULED_LINE : null;
}
